import { createSlice } from "@reduxjs/toolkit"



const initialState={
    
    currentAdminA:null,
    isLoginA:false,
}

const adminASlice=createSlice({
name:'adminA',

initialState,
reducers:{
    loginStartA:(state)=>{

    },
    loginSuccessA:(state,{payload})=>{
        state.isLoginA=true;
        state.currentAdminA=payload;
        

    },
    loginFailureA:(state)=>{


    },
    logOutA:(state)=>{
        state.isLoginA=false;
        state.currentAdminA='';

    }
    

}
})
export const {loginStartA,loginFailureA,loginSuccessA,logOutA}=adminASlice.actions

export default adminASlice.reducer